import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      position: 'relative',
      width: 200,
      height: 200,
      overflow: 'visible',
    },
    pad: {
      width: 200,
      height: 200,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 16,
      borderWidth: 2,
      rowGap: 26,
      backgroundColor: colors.popup,
      borderColor: colors.border,
      shadowColor: colors.black,
      shadowOpacity: 0.12,
      shadowOffset: { width: 0, height: 1 },
      shadowRadius: 2,
      elevation: 1,
    },
    status: {
      width: 80,
      height: 6,
      borderRadius: 3,
      backgroundColor: colors.neutral,
    },
    statusError: {
      backgroundColor: colors.negative,
    },
    card: {
      position: 'absolute',
      top: 80,
      width: 128,
      height: 80,
    },
    foreground: {
      width: 128,
      height: 80,
      borderRadius: 8,
      zIndex: 2,
      backgroundColor: colors.neutral,
    },
    foregroundError: {
      backgroundColor: colors.negative,
    },
    shadow: {
      position: 'absolute',
      left: -8,
      bottom: -8,
      width: 128,
      height: 80,
      borderRadius: 8,
      backgroundColor: colors.elevation3,
      zIndex: 1,
    },
    chip: {
      position: 'absolute',
      width: 24,
      height: 16,
      top: 20,
      left: 14,
      borderRadius: 3,
      backgroundColor: colors.elevation1,
    },
  });
